<template>
  <div class="fc rightsTitleBox">
    <img :style="{ width: imgWidth }" class="imgNomal" src="../../assets/images/lineLong.png" alt="" />
    <span :style="[{ fontSize: size + 'px' }, { transform: `scale(${scaleN})` }]">{{ text }}</span>
    <img :style="{ width: imgWidth }" class="imgReverse" src="../../assets/images/lineLong.png" alt="" />
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'

export default {
  props: ['text', 'size', 'imgWidth', 'scaleN'],
  setup(props) {
    const state = reactive({
      count: 0,
      text: props.text,
      size: props.size || 14,
      imgWidth: props.imgWidth,
      scaleN: props.scaleN || 1
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.rightsTitleBox {
  padding: 10px 0;
  background: #f5f5f5;
  span {
    // margin: 0 20px;
    padding: 0 10px;
    font-size: 14px;
    // font-weight: bold;
    flex: 1;
    text-align: center;
  }
}
.imgNomal {
  transform: rotate(360deg);
}
.imgReverse {
  transform: rotate(180deg);
}
</style>
